export default class functionHelper
{
	static isFunction(functionToCheck) {
        let result=typeof functionToCheck === 'function';
        return result;
    }

	
	
}
